import { useSelector } from 'react-redux';
import { useCallback } from 'react';

import { selectServicePageInfo } from '../../../selectors/servicePageInfo';
import { createCianAnalyticsPageViewObject } from '../../../utils/createCianAnalyticsPageViewObject';
import { trackEvent } from '../../../utils/tracking';
import { EAddressCadastreSpecialFlowValidationErrorCodes, IInputModeChangeHandler } from '../types';

export interface IUseAddressCadastreTrackingResult {
  trackInputModeChange: IInputModeChangeHandler;
  trackSpecialFlowValidationError: (error: EAddressCadastreSpecialFlowValidationErrorCodes) => void;
}

export const useAddressCadastreFieldTracking = (): IUseAddressCadastreTrackingResult => {
  const servicePageInfo = useSelector(selectServicePageInfo);

  const trackInputModeChange = useCallback<IInputModeChangeHandler>(
    mode => {
      trackEvent({
        action: 'Click',
        label: mode,
        ...createCianAnalyticsPageViewObject(servicePageInfo),
      });
    },
    [servicePageInfo],
  );

  const trackSpecialFlowValidationError = useCallback<(error: EAddressCadastreSpecialFlowValidationErrorCodes) => void>(
    error => {
      trackEvent({
        action: 'Show_warning',
        label: error,
        ...createCianAnalyticsPageViewObject(servicePageInfo),
      });
    },
    [servicePageInfo],
  );

  return {
    trackInputModeChange,
    trackSpecialFlowValidationError,
  };
};
